import { CircularProgress, Typography } from '@mui/material';
import CircularProgressWithLabel from 'Components/CircularProgress';
import useTranslation from 'Hooks/useTranslation';
import { DropzoneArea, DropzoneText, spanStyle } from 'Pages/EditCourseLessons/Views/LessonVideo/style';
import React from 'react';

/**
 * @typedef {Object} Props
 * @property {Object} descriptions - Descripciones para el indicador de carga.
 * @property {string} descriptions.loadingDescription - Descripción para el indicador de carga.
 * @property {string} descriptions.dragAndDropDescription - Descripción para el área de dropzone.
 * @property {string} descriptions.typeErrorDescription - Descripción para el error de tipo de archivo.
 * @property {boolean} loading - Indica si el indicador de carga es visible.
 * @property {Function} getInputProps - Función para obtener las propiedades del input.
 * @property {Function} getRootProps - Función para obtener las propiedades del root.
 * @property {string} uploadFiles - Imagen de subida de archivos.
 * @property {Array} acceptedFileItems - Archivos aceptados.
 * @property {Array} fileRejectionItems - Archivos rechazados.
 */

/**
 * Muestra un indicador de carga para el área de dropzone.
 * Este componente es utilizado cuando se usan los servicios de "Amazon S3".
 *
 * @param {Props} props - Propiedades del componente.
 *
 */
const DropzoneAreaLoadingIndicator = ({
  descriptions,
  loading,
  getInputProps,
  getRootProps,
  uploadFiles,
  acceptedFileItems,
  fileRejectionItems,
}) => {
  // Traducción
  const { t2 } = useTranslation('EditCourse');

  if (loading)
    return (
      <CircularProgressWithLabel
        variant="indeterminate"
        description={descriptions?.loadingDescription || t2('UploadVideo')}
      />
    );

  return (
    <DropzoneArea {...getRootProps({ className: 'dropzone' })}>
      <input {...getInputProps()} />
      <img style={{ width: '20%', marginTop: '1rem' }} src={uploadFiles} />
      <DropzoneText>
        <p style={{ textAlign: 'center' }}>
          {descriptions?.dragAndDropDescription || t2('DragAndDropVideo')}
          <br />
          <br />
          {t2('Find')}
          <span style={spanStyle}>{t2('Desktop')}</span>
        </p>
        <div style={{ margin: 'auto' }}>{acceptedFileItems}</div>
        {fileRejectionItems.length > 0 && (
          <h4 style={{ color: 'red', margin: '0' }}>
            {descriptions?.typeErrorDescription || t2('VideoUploadTypeError')}
          </h4>
        )}
      </DropzoneText>
    </DropzoneArea>
  );
};

export default DropzoneAreaLoadingIndicator;
